import { getOntologyApiBaseUrl } from '../../config'
import { createOntologyHeaders, saveBlob } from '../core'

export async function downloadMaintenanceBackup(
  label: string,
  route: string,
  fileName: string
): Promise<void> {
  const headers = createOntologyHeaders()
  // GET with no JSON body — drop the default Content-Type from createOntologyHeaders.
  headers.delete('Content-Type')

  const res = await fetch(`${getOntologyApiBaseUrl()}/maintenance/${route}`, {
    headers
  })
  if (!res.ok) {
    const text = await res.text().catch(() => '')
    let message = text
    try {
      const parsed = JSON.parse(text) as { message?: string; error?: string }
      message = parsed.message || parsed.error || text
    } catch {
      // keep raw text
    }
    throw new Error(
      `${label} backup download failed (${res.status})${message ? `: ${message}` : ''}`
    )
  }
  saveBlob(await res.blob(), fileName)
}
